import "./OfficeTour.module.css";
import Header from "@/reusable_sections/Header";
import GalleryHero from "./sections/GalleryHero";
import PhotoGallery from "./sections/PhotoGallery";
import VirtualTourCta from "./sections/VirtualTourCta";
import Footer from "@/reusable_sections/Footer";
export default function OfficeTourPage() {
  return <div>
      <Header />
      <GalleryHero />
      <PhotoGallery />
      <VirtualTourCta />
      <Footer />
    </div>;
}